/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * RecommendationStatusType explains what is the current state of recommendations.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1RecommendationStatusType = {
    UNKNOWN: 'STATUS_UNKNOWN',
    WAITING: 'STATUS_WAITING',
    APPLIED: 'STATUS_APPLIED',
    STOPPED: 'STATUS_STOPPED'
} as const;

export type WorkloadoptimizationV1RecommendationStatusType = typeof WorkloadoptimizationV1RecommendationStatusType[keyof typeof WorkloadoptimizationV1RecommendationStatusType];



